import React, { useEffect, useState } from "react";
import { Button, Switch, message } from "antd";
import "./payment.scss";
import PaymentCard from "./PaymentCard";
import { httpService } from "../../../services/httpService.service";
import { Footer, Header } from "antd/es/layout/layout";
import AdminHeader from "../../components/AdminHeader/AdminHeader";
import back from "../../../Assets/svg/back.svg";
import FooterComponent from "../../components/FooterComponent/FooterComponent";
import { useNavigate } from "react-router-dom";

const Payment = () => {
  const [cards, setCards] = useState([]);
  const [billedType, setBilledType] = useState("annually");
  const [selectedPlanId, setSelectedPlanId] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const goBack = () => {
    navigate("/dashboard/contracts");
  };

  useEffect(() => {
    httpService.get("/api/Payment/getPackets", (res) => {
      setCards(res?.data || []);
    });
  }, []);

  const handleContinue = () => {
const selectedPlan = cards.find(c => c.id === selectedPlanId);

if (selectedPlan?.prices?.length === 0) {
  window.location.href = "https://tpmready.com/contact/";
  return;
}

const selectedPrice = selectedPlan.prices.find(p =>
  billedType === "annually" ? p.annualPrice > 0 : p.monthlyPrice > 0
);

if (!selectedPrice?.stripePriceId) {
  message.error("Invalid plan selected");
  return;
}

const baseUrl = window.location.origin;

const payload = {
  priceId: selectedPrice.stripePriceId,
  successUrl: `${baseUrl}/payment-success`,
  failureUrl: `${baseUrl}/payment-failure`,
};
    setLoading(true);

    httpService.post(
      "/api/Payment/createCheckoutSession",
      payload,
      (res) => {
        setLoading(false);
        if (res?.data?.sessionUrl) {
          window.location.href = res.data.sessionUrl;
        }
      },
      () => {
        setLoading(false);
        message.error("Something went wrong. Please try again.");
      }
    );
  };
  return (
    <>
      <Header
        className="adminHeader "
        style={{ minHeight: "0 !important", padding: "0px !important" }}
      >
        <div
          style={{ display: "flex" }}
          onClick={() => {
            // localStorage.removeItem("roleId");
            goBack();
          }}
        >
          <img src={back} style={{ cursor: "pointer" }}></img>{" "}
          <span className="backText">Go back to contracts</span>
        </div>
        <AdminHeader
        // notifications={notifications}
        // setNotifications={setNotifications}
        // unreadNotifications={unreadNotifications}
        // setUnreadNotifications={setUnreadNotifications}
        >
          {" "}
        </AdminHeader>
      </Header>

      <div className="paymentWrapper container-fluid">
        <h1 className="text-center mb-4">Choose the perfect plan for you</h1>

        <div className="billingToggle d-flex justify-content-center align-items-center gap-2 mb-4">
          <Switch
            checked={billedType === "monthly"}
            checkedChildren="Monthly"
            unCheckedChildren="Yearly"
            onChange={(checked) =>
              setBilledType(checked ? "monthly" : "annually")
            }
          />
        </div>

        {/* Cards */}
        <div className="cardWrapper d-flex gap-4 justify-content-center flex-wrap">
          {cards.map((item) => (
            <PaymentCard
              key={item.id}
              item={item}
              billedType={billedType}
              isSelected={selectedPlanId === item.id}
              onSelect={() => setSelectedPlanId(item.id)}
            />
          ))}
        </div>

        <div className="continueWrapper text-center mt-4">
          <Button
            type="primary"
            disabled={!selectedPlanId}
            loading={loading}
            className="addButtonTPM"
            onClick={handleContinue}
          >
            Continue
          </Button>
        </div>
      </div>
      <Footer>
        <FooterComponent></FooterComponent>
      </Footer>
    </>
  );
};

export default Payment;
